import React, { Component } from 'react';
import { Link } from "react-router-dom"
import { Container, CardColumns, CardDeck, Card, Button } from 'react-bootstrap'
import Header from './Header'
import tokenCreator from '../ethereum/tokenCreator'

class TokensIndex extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tokens: []

    }
  }

  async componentDidMount() {
    const tokens = await tokenCreator.methods.getTokens().call()

    this.setState({
      tokens
    })
  }

  render() {
    return (

      <Container >
        <Header />
        <div style={{ marginTop: '15px' }}>
          <CardDeck className="text-center">
            <Card style={{ width: '18rem' }}>
              <Card.Body>
                <Card.Title>Create Token</Card.Title>
                <Card.Text>
                  Creat your own token!
              </Card.Text>
                <Card.Text>
                  It's easy!
              </Card.Text>
                <br />
                <Link to="/newtoken"><Button variant="success">Create Token</Button></Link>
              </Card.Body>
            </Card>

            <Card style={{ width: '18rem' }}>
              <Card.Body>
                <Card.Title>Sell Tokens</Card.Title>
                <Card.Text>
                  Want to sell your tokens?
             </Card.Text>
                <Card.Text>
                  It's easy!
             </Card.Text>
                <br />
                <Link to="/newsale"><Button variant="success">Sell Token</Button></Link>
              </Card.Body>
            </Card>

            <Card style={{ width: '18rem' }}>
              <Card.Body>
                <Card.Title>Buy Tokens</Card.Title>
                <Card.Text>
                  Want to buy tokens?
             </Card.Text>
                <Card.Text>
                  It's easy!
             </Card.Text>
              </Card.Body>
              <Card.Body >
                <Link to="/market"><Card.Text style={{ fontSize: '30px', color: '#00b300' }}>Token Market</Card.Text></Link>

              </Card.Body>
            </Card>
          </CardDeck>
        </div>
        <Container style={{ marginTop: '15px', backgroundColor: '#f2f2f2' }}>
          <h3 className="text-center">Token Factory</h3>
          <CardColumns>

            {this.state.tokens.map(token => (
              <Card border="success" className="text-center">
                <Card.Title>Token</Card.Title>
                <Card.Title>{token}</Card.Title>
                <Link to={`/tokens/${token}`}><Button variant="outline-success">Token Details</Button></Link>
              </Card>
            ))}

          </CardColumns>
        </Container>
      </Container>

    )
  }
}

export default TokensIndex;
